import { getUrlParamValue } from './urlTools';
import { getSelectedPacsConfig } from './pacsSelectorConfig';

export const getAuthHeader = (appConfig) => {
  const { AUTH_TOKEN_FROM_URL_PARAM, AUTH_TOKEN_FROM_URL_PARAM_NAME, CLOUD_WITH_AUTH, WITH_HEADERS, AUTH_FOR_HEADERS } = appConfig;

  if (AUTH_TOKEN_FROM_URL_PARAM && typeof AUTH_TOKEN_FROM_URL_PARAM_NAME === 'string') {
    const urlParamValue = getUrlParamValue(AUTH_TOKEN_FROM_URL_PARAM_NAME);
    if (typeof urlParamValue === 'string') {
      return `Bearer ${urlParamValue}`;
    }
  }

  if (CLOUD_WITH_AUTH) {
    return null;
  }

  const selectedPacsConfig = getSelectedPacsConfig(appConfig);

  if (selectedPacsConfig?.authHeader) {
    return selectedPacsConfig.authHeader;
  }

  if (WITH_HEADERS) {
    return AUTH_FOR_HEADERS;
  }

  return null;
};
